export class EventDetailsModel {
  public id: number;
  public ongoing: string;
  public name: string;
  public timeFrom: Date;
  public timeTo: Date;
  public location: string;
  public longitude: number;
  public latitude: number;
  public maxNumberOfAttendees: number;
  public description: string;
  public isAlive: boolean;
  public maxNumberOfGuestPerUser: number;
  public appResponseAttending: string;
  public appResponseWaiting: string;
  public deadLine: Date;
  public mailTemplateAttending: string;
  public images: Array<EventDetailsImage>  ;
  constructor() {
    this.id = 0;
    this.ongoing = 'false';
    this.name = 'Create Listing';
    this.timeFrom = new Date();
    this.timeTo = new Date();
    this.location = '';
    this.longitude = 41;
    this.latitude = 0;
    this.maxNumberOfAttendees = 100;
    this.description = '';
    this.isAlive = true;
    this.maxNumberOfGuestPerUser = 5;
    this.appResponseAttending = '';
    this.appResponseWaiting = '';
    this.deadLine = new Date();
    this.mailTemplateAttending = '';
    this.images = new Array<EventDetailsImage>();
  }
}
export class EventDetailsImage {
  public url: string;
  public imageId: number;
  public mime: string;
  public data: File;
  public order: number;
  public fileIndex: number;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-details/event-details.model.ts